import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../assets/css/disclaimerPage.module.css';

const DisclaimerPage: React.FC = () => {
  return (
    <div className={styles.disclaimerPage}>
      <div className={styles.disclaimerContainer}>
        <h1 className={styles.makeBlue}>Horry County GIS Application</h1>
        <p>The Data is provided &quot;as is&quot; without warranty or any representation of accuracy, timeliness or completeness. The burden for determining accuracy, completeness, timeliness, and fitness for or the appropriateness for use rests solely on the user. Horry County makes no warranties, express or implied, as to the use of the Data. There are no implied warranties or warranties of fitness for a particular purpose or merchantability, and Horry County shall have no liability for actual or consequential losses arising from use of the data. The GIS data and mapping application represent the parcel fabric as used for taxing purposes and not for survey purposes.</p>
        <p><Link to="/">Back to App</Link></p>
      </div>
    </div>
  )
}

export default DisclaimerPage;